export default __webpack_public_path__ + "assets/bioclinico-component.36f41e38.svg";